import {Routes, Route, Navigate, useLocation} from 'react-router-dom'
import Lottie from 'react-lottie'
import * as animationData from '../assets/animations/DesktopHouses.json'

import styles from './App.module.scss'
import {
  Login,
  PasswordReset,PasswordRestore,
  SignUp,
  AMLManualCheck,
  AMLGreenIDCheck,
} from 'modules/auth'
// import {Box} from 'common/components'
import useStore from './store'
import {AppContent, Header} from '.'

const defaultOptions = {
  loop: true,
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export default function App() {
  const session = useStore((state) => state.session)
  const {pathname} = useLocation()

  const isManual = pathname.startsWith('/manual')
  const isGreenID= pathname.startsWith('/green-id')

  if (!session || isManual || isGreenID )
    return (
      // <Box fadeIn as="main" className={styles.secondRoot}>
      <div style={{
        backgroundColor: '#272727',
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
      }}>
      { (!isManual && !isGreenID) &&
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1,
        }}>
          <Lottie options={defaultOptions}
            // height={400}
            // width={600}
            isStopped={false}
            isPaused={false}
          />
        </div>
      }

        <div style={{
          position: 'relative',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'transparent',
          zIndex: 2,
        }}>

          <Routes>
            <Route path="manual/:token" element={<AMLManualCheck />} />
            <Route path="green-id/:token" element={<AMLGreenIDCheck />} />
            <Route path="login" element={<Login />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="password-reset" element={<PasswordReset />} />
            <Route path="password-restore" element={<PasswordRestore />} />
            <Route path="*" element={<Navigate replace to="login" />} />
          </Routes>

        </div>
        <div style={{height: '198px'}}></div>

      </div>
      // </Box>
    )

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <Header />
        <AppContent />
      </div>
    </div>
  )
}
